import { CommonModule, Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MeasureUnite } from '../../../models/measureUnite.model';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ModalComponent } from '../../../components/modal/modal.component';
import { CreateMeasureOfUnitComponent } from "../create-measure-of-unit/create-measure-of-unit.component";
import { MeasureUniteService } from '../measure-unite.service';
import { PaginatorModule } from 'primeng/paginator';

@Component({
  selector: 'app-list-measure-of-unit',
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    ModalComponent,
    CreateMeasureOfUnitComponent,
    PaginatorModule
],
  templateUrl: './list-measure-of-unit.component.html'
})
export class ListMeasureOfUnitComponent implements OnInit{

  uniteId!: number | null;
  searchTerm: string = '';
  measureUnities: MeasureUnite[] = [];
  loading: boolean =  true;
  totalRecords: number = 0;
  formVisible: boolean = false;

  first: number = 0;
  rows: number = 5;
  currentPage: number = 1;

  constructor(private location: Location, private measureUniteService: MeasureUniteService)
  {

  }

  ngOnInit(): void {
    this.getData();
  }

  getData(){
    this.measureUniteService.getAll(this.searchTerm, null, true, this.currentPage).subscribe({
      next: (data) => {
        this.measureUnities = data.data;
        this.totalRecords = data.pagination.totalRecords;
        this.loading = false;
      },
      error:(error) => {
        this.loading = false;
      }
    })
  }

  create(){
    this.changeModal();
  }

  onPageChange(event: any){
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.getData();
  }

  changeModal(){
    this.formVisible = !this.formVisible;
  }

  closeModal(){
    this.uniteId = null;
  }

  edit(unite: MeasureUnite){
    this.uniteId = unite.id;
    this.changeModal();
  }

  onFormSubmit(){
    this.changeModal();
    this.getData();
  }

  goBack(){
    this.location.back();
  }

}
